// extracted by mini-css-extract-plugin
module.exports = {"root":"Table_root__1gO0A","head":"Table_head__2n81z","col":"Table_col__UFfdD"};